import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom';
import App, { store } from './App';
import { Provider } from 'react-redux';
import HttpsRedirect from 'react-https-redirect';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './contexts/ThemeContext';

// Error monitoring (Wave 1.2). DSN-gated: with no REACT_APP_SENTRY_DSN set,
// Sentry.init is never called, so this is a complete no-op (no reporting,
// no console noise) in local dev / any build without the env var. Set the
// DSN as a REACT_APP_SENTRY_DSN build-time env var to activate. The DSN
// itself is safe to expose in the browser bundle (it's a publishable
// ingest key, not a secret — unlike the Stripe key incident).
if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || 'development',
    // REACT_APP_VERSION (e.g. a git SHA from CI) ties errors to a release;
    // optional — undefined just means "no release tag".
    release: process.env.REACT_APP_VERSION || undefined,
    // Performance tracing sample rate (errors are captured regardless of
    // this). 0.1 keeps quota use modest for a low-traffic B2B app; raise
    // if you want fuller transaction data.
    tracesSampleRate: 0.1,
  });
}

ReactDOM.render(
  <HttpsRedirect>
    <Provider store={store}>
      <ErrorBoundary>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </ErrorBoundary>
    </Provider>
  </HttpsRedirect>,
  document.getElementById('root')
);
